






















































































































































import Vue from 'vue'
import mixins from 'vue-typed-mixins'

import Process from '@/components/workflow/Process.vue'
import Task from '@/components/workflow/Task'
import Timer from '@/components/workflow/Timer'
import Gateway from '@/components/workflow/Gateway'
import AuthorizationMixin from '@/routing/AuthorizationMixin'
import { Booking } from '@/store/interview/bookings/types'

export default mixins(AuthorizationMixin).extend({
  components: { Process, Task, Timer, Gateway },
  computed: {
    myActiveBooking(): Booking | undefined {
      const bookings = (this.$store.getters[
        'interview/bookings/asInterviewee'
      ] as Booking[]).filter(booking => !booking!.offer!.post && !booking!.canceled)

      if (bookings.length > 0) {
        return bookings[0]
      } else {
        return undefined
      }
    },
  },
})
